import { useLocation } from "react-router-dom";
import parsePhoneNumber from "libphonenumber-js";
import {
  browserName,
  isMobile,
  isTablet,
  osName,
  osVersion,
} from "react-device-detect";
import moment from "moment";

import Country from "../models/Country";

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function singleSpace(s: string): string {
  if (s.length === 0) return s;
  return s.replace(/\s\s+/g, " ");
}

export function removeSpace(value: string): string {
  if (value.length === 0) return value;
  return value.split(/\s+/).join("");
}

export function groupByNDigit(value: string, digit: number): string {
  if (value.length === 0 || digit <= 0) return value;

  let regex = new RegExp("\\d{1," + digit + "}", "g");
  let result = value.toString().match(regex);

  return result.join(" ");
}

export function base64(
  file: File,
  callback: (result: string | ArrayBuffer | null) => void
): void {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    callback(reader.result);
  };

  reader.onerror = function (error) {
    console.dir("base64 :: ", error);
    callback(null);
  };
}

export function base64toFile(base64: string, filename: string): File | null {
  if (base64! === undefined || base64 === null || base64.length === 0)
    return null;

  let buffer = base64.split(","),
    mime = buffer[0].match(/:(.*?);/)[1],
    bufferStr = atob(buffer[1]),
    n = bufferStr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bufferStr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export function formatPhoneNumber(
  value: string,
  withDialCode: boolean = true
): string {
  if (!value) return value;

  const phoneNumberProto = parsePhoneNumber(value);

  if (withDialCode) {
    return phoneNumberProto
      ? "+" +
          phoneNumberProto.countryCallingCode +
          " " +
          phoneNumberProto.formatNational().toString()
      : value;
  }

  return phoneNumberProto
    ? phoneNumberProto.formatNational().toString()
    : value;
}

export function phoneNumberToCountry(value: string): any {
  if (!value) return null;

  const phoneNumberProto = parsePhoneNumber(value);

  return phoneNumberProto
    ? {
        country: new Country(
          "",
          phoneNumberProto.countryCallingCode.toString(),
          phoneNumberProto.country as string
        ),
        nationalValue: phoneNumberProto.formatNational().toString(),
        number: phoneNumberProto.number.toString(),
      }
    : null;
}

export function parseDate(strDate: string | null | undefined): Date | null {
  if (strDate === null || strDate === undefined || strDate.length === 0) {
    return null;
  }

  let date = moment.utc(strDate).local();

  return new Date(date.toString());
}

export function deviceInfo(): any {
  let deviceType = isMobile || isTablet ? "Mobile/Tablet" : "PC";
  let deviceOS = `${osName} ${osVersion}/${browserName}`;

  return {
    device_name: deviceType,
    device_model: deviceOS,
  };
}

export function parseJson(data: string | null): any {
  if(data === null) {
    return data;
  }

  return JSON.parse(JSON.stringify(data));
}

export function toMegaBytes(octets: number): number {
  return octets === 0 ? octets : octets / 1024 / 1024;
}

export function validateFile(file: string | File, maxSize: number): boolean {
  if (file instanceof File) {
    return toMegaBytes(file.size) <= maxSize;
  }

  const fileOutput = base64toFile(file, "");
  return toMegaBytes(fileOutput.size) <= maxSize;
}

export function randomColor() {
  let hex = Math.floor(Math.random() * 0xffffff);

  return "#" + hex.toString(16);
}

export function initials(value: string) {
  if (value) {
    return singleSpace(value)
      .split(" ")
      .map((item) => item.charAt(0))
      .join("")
      .substr(0, 2)
      .toUpperCase();
  }

  return value;
}
